webpackJsonp([55060502200624],{

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var firstVisit = function firstVisit() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h2',
	      null,
	      'First Visit'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'Before your treatment:'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'For your first treatment, please arrive 15-20 minutes early to fill out this ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/patient-forms' },
	        'paperwork'
	      ),
	      ', or have it with you when you arrive.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Please arrive wearing comfortable clothes and having eaten within the last 2-3 hours.'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'What to Expect:'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Your first treatment will last between 75-90 minutes. We will take this time to discuss your case in depth and to answer any questions you have about acupuncture and Chinese medicine.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Follow up visits usually last between 45-60 minutes.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'At your first visit, we will spend some time talking about the condition you would like to treat, as well as your health in general. I will ask questions to help me understand how best to treat your condition in the context of your overall health and lifestyle.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'At each session, I will do a physical assessment, which may include feeling your pulse, looking at your tongue, and feeling your abdomen or acupuncture points along your arms and legs. Based on our interview and these findings, I will make a Chinese medical diagnosis and individualized treatment plan.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'At each session, I will choose acupuncture points and techniques that are appropriate to you on that day. I use a wide variety of acupuncture techniques and will use the one that best fits your condition and level of comfort.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In addition to acupuncture, I may also use other techniques, such as moxibustion (the burning of warming herbs near an acupuncture point), or cupping (creating a partial vacuum with glass or plastic cups as a way to relax tissues and stimulate blood flow), and the use of infra-red heat therapy.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'After your treatment, we will take a few moments to discuss the treatment plan, herbal medicine, and any exercises or lifestyle advice that may be important to your condition.'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'What do acupuncture needles feel like?'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Acupuncture needles are fine, sterile, and used only once. Some people have no sensation at all when the needles are inserted, while others may feel a slight pinch, followed by a dull ache or tingling sensation, all normal sensations within an acupuncture treatment.'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'How long do the needles stay in?'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Acupuncture needles are left in between 10 and 30 minutes. Many people find that during this time, they experience a deep sense of relaxation, and may even fall asleep.'
	    ),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'How many treatments will you need?'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The number of treatments required varies based on the individual and the condition. Some conditions may resolve in one session. A series of 5-10 treatments is fairly common. Other conditions, particularly those that are degenerative or long-standing, may require several months of treatment or require on-going care.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Conditions may require the use of herbal medicine, dietary modifications, exercises or lifestyle modifications. Incorporating these therapies will improve treatment efficacy and helps to shorten the treatment period. While conditions may not resolve immediately, signs that the treatment is helping should be apparent to both the patient and practitioner early on in the process.'
	    )
	  );
	};
	
	exports.default = firstVisit;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-first-visit-js-850395d603ccf963e7f3.js